// module.exports = {
//     baseUrl: 'https://localhost:44328',
//     authority: 'https://localhost:5001',
//     logoutUrl: 'http://localhost:8081',
//     envUrl: 'http://localhost:8081'
// }
module.exports = {
    logoutUrl: 'happypurim.com',
    baseUrl: 'https://api.happypurim.app',
    // baseUrl: 'https://localhost:44328',
    authority: 'https://id.happypurim.app'
}
 // logoutUrl: 'hrh.happypurim.app',
 // baseUrl: 'https://localhost:44328',